import type { ActivityCardEntry } from "./types";

type BadgeVariant = "default" | "outline" | "destructive" | "success" | "custom";

export const getBadgeStyles = (variant: ActivityCardEntry["badgeVariant"]): { variant: BadgeVariant; className: string } => {
  switch (variant) {
    case "success":
      return { variant: "success", className: "" };
    case "destructive":
      return { variant: "destructive", className: "" };
    case "warning":
      return { variant: "custom", className: "bg-orange-500 text-white hover:bg-orange-500/80" };
    default:
      return { variant: "outline", className: "" };
  }
};
